import { Component, OnInit } from '@angular/core';
import { ClientMainBarService } from 'src/app/layout/client/client-main-bar/client-main-bar.service';

@Component({
  selector: 'app-applyment-access',
  template: ``,
  styles: []
})
export class ApplymentAccessComponent implements OnInit {

  constructor(private clientMainBarService: ClientMainBarService) { }

  ngOnInit(): void {
    this.clientMainBarService.setHeaderHideState(true);
  }

}
